/**
 * Demo interest test paper used when no published papers are available.
 * Structure mirrors the test paper schema used by ability-style tests.
 */
import { simplifiedInterestTestPaper } from './simplifiedInterestTestPaper.js';

export const DEMO_INTEREST_QUESTIONNAIRE_PAPERS = [simplifiedInterestTestPaper];
